export default __webpack_public_path__ + "static/media/page-loader.4f20e6b2.gif";